import { ChangeDetectionStrategy, Component, inject, Type } from '@angular/core';
import { MapItem, MapItemComponent } from '@ui/shared/util-map';
import { ToResult } from '@team23/ts-result';
import { SelectedItemState } from '@ui/shared/domain-map';
import { type Identificable, MapItemService } from '@ui/shared/feature-map';
import { ListItem, type ListItemComponent } from '@ui/shared/util-list';

@Component({
    selector: 'ui-root',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseAppComponent<Item extends MapItem | ListItem> {
    protected readonly _mapItemService = inject(MapItemService<Item>);
    protected readonly _selectedItemState = inject(SelectedItemState<Item>);

    public readonly mapItems$ = this._mapItemService.mapItems$;

    public readonly fallbackMapItems = ToResult.fromData([]);

    public readonly detailViewItem$ = this._selectedItemState.mapItem$;

    constructor(
        public popupContentComponentType: Type<Item extends MapItem ? MapItemComponent<Item> : ListItemComponent<Item>>,
    ) {}

    public reloadMapData(): void {
        this._mapItemService.reloadMapData();
    }

    public openMapItemById(item: Identificable): void {
        this._mapItemService.openMapItemById(item);
    }
}
